"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayMusicAction = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var inversify_1 = require("inversify");
var PlayMusicAction = (function (_super) {
    tslib_1.__extends(PlayMusicAction, _super);
    function PlayMusicAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlayMusicAction_1 = PlayMusicAction;
    PlayMusicAction.prototype.execute = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var active, sprite, howlInstance, howl, hasMusicInstance;
            return tslib_1.__generator(this, function (_a) {
                active = payload.active, sprite = payload.sprite, howlInstance = payload.howlInstance;
                howl = howlInstance || (0, core_1.lazyGet)("howl_music");
                if (!howl) {
                    return [2];
                }
                hasMusicInstance = !isNaN(PlayMusicAction_1.activeMusicState.instance);
                if (active) {
                    if (hasMusicInstance) {
                        if (!PlayMusicAction_1.activeMusicState.playing) {
                            PlayMusicAction_1.activeMusicState.playing = true;
                            this.fadeTo(howl, 1, PlayMusicAction_1.activeMusicState.instance);
                        }
                    }
                    else {
                        PlayMusicAction_1.activeMusicState.instance = howl.play(sprite || "track") || NaN;
                        PlayMusicAction_1.activeMusicState.playing = true;
                    }
                }
                else {
                    if (PlayMusicAction_1.activeMusicState.playing) {
                        PlayMusicAction_1.activeMusicState.playing = false;
                        if (hasMusicInstance) {
                            this.fadeTo(howl, 0, PlayMusicAction_1.activeMusicState.instance);
                        }
                    }
                }
                return [2];
            });
        });
    };
    PlayMusicAction.prototype.fadeTo = function (howl, to, trackId, duration) {
        if (duration === void 0) { duration = 500; }
        var from = howl.volume();
        duration *= Math.abs(Math.min(from, to) - Math.max(from, to));
        howl.fade(from, to, duration, trackId);
    };
    var PlayMusicAction_1;
    PlayMusicAction.activeMusicState = { playing: false };
    PlayMusicAction = PlayMusicAction_1 = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], PlayMusicAction);
    return PlayMusicAction;
}(core_1.Action));
exports.PlayMusicAction = PlayMusicAction;
//# sourceMappingURL=PlayMusicAction.js.map